import { Directive, AfterViewInit, Input, Renderer2, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[artemisEnginesOptionDynamicHeight]'
})
export class EnginesOptionDynamicHeightDirective implements AfterViewInit {

  _searchEngineCount: number;

  @Input() set searchEngineCount(value: number) {
    if (value) {
      this._searchEngineCount = value;
      this.adjustHeight();
    }
  }

  get searchEngineCount() {
    return this._searchEngineCount;
  }

  @HostListener('window:resize') onResize() {
    this.adjustHeight();
  }

  constructor(private renderer: Renderer2,
              private elementRef: ElementRef) { }

  ngAfterViewInit() {

  }

  adjustHeight(): void {
    const rowHeightDesktop: number = 45;
    const rowHeightMobile: number = 60;
    const columnCount: number = 2;

    const mobileBreakPoint: number = 767;

    let totalHeight: number;

    if (window.innerWidth > mobileBreakPoint) {
      totalHeight = Math.ceil(this.searchEngineCount / columnCount) * rowHeightDesktop;
    } else {
      totalHeight = Math.ceil(this.searchEngineCount / columnCount) * rowHeightMobile;
    }

    this.renderer.setStyle(this.elementRef.nativeElement, 'height', totalHeight + 'px');
  }

}
